import { render, staticRenderFns } from "./PublicPage.vue?vue&type=template&id=285ca284&scoped=true"
import script from "./PublicPage.vue?vue&type=script&lang=js"
export * from "./PublicPage.vue?vue&type=script&lang=js"
import style0 from "./PublicPage.vue?vue&type=style&index=0&id=285ca284&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285ca284",
  null
  
)

export default component.exports